/**
 * 名前空間 `common` — 共通部品 (components/common/) の文言。依頼者ポータルでも使う部品は Provider の外なので日本語のまま描かれる。
 * 文言は `locales/ja/common.ts` (正本) と `locales/en/common.ts`。画面は `useT(commonNs)`。
 */
import { defineNamespace } from '../registry';
import { commonEn } from '../locales/en/common';
import { commonJa } from '../locales/ja/common';

export const commonNs = defineNamespace('common', commonJa, commonEn, {
  knownMessages: [
    'knownMessages.forbiddenAccess',
    'knownMessages.forbiddenOperation',
    'knownMessages.sessionExpired',
    'knownMessages.requestAborted',
    'knownMessages.requestTimedOut',
    'knownMessages.copyFailed',
  ],
});
